import { IGetAvgPriceAndMortgageRateResponse } from '../../../repositories/investment-calculator/v1/get-avg-price-and-mortgage-rate';
import { IFlatStats, TFlatStatsEntries } from '../../../types/flatStats';

export function prepareFlatStats(response: IGetAvgPriceAndMortgageRateResponse): IFlatStats {
  const items = response.items.reduce<TFlatStatsEntries>((acc, item) => {
    acc[item.rooms] = {
      avgMortgageRate: item.avgMortgageRate,
      avgPrice: item.avgPrice,
      avgIncrease: item.avgIncrease,
    };

    return acc;
  }, {} as TFlatStatsEntries);

  return {
    items,
    regionId: response.regionId,
  };
}
